import { Chess } from 'chess.js';

// Reasons the current position couldn't arise in a legal game — shown as a
// warning banner and used to switch the engine off (Stockfish misbehaves on
// impossible positions). Positions missing a king are "setup mode" and
// handled separately, so they return no warnings here.
export function positionWarnings(fen) {
  const warnings = [];
  const parts = fen.split(' ');
  const boardField = parts[0];
  const turn = parts[1];

  const whiteKings = (boardField.match(/K/g) || []).length;
  const blackKings = (boardField.match(/k/g) || []).length;
  if (whiteKings === 0 || blackKings === 0) return warnings;

  // pawns on the first or eighth rank
  const ranks = boardField.split('/');
  if (/[pP]/.test(ranks[0]) || /[pP]/.test(ranks[7])) {
    warnings.push('pawn on the first or eighth rank');
  }

  let game;
  try {
    game = new Chess(fen, { skipValidation: true });
  } catch {
    return warnings;
  }

  // kings on adjacent squares
  const kings = {};
  for (const rank of game.board()) {
    for (const cell of rank) {
      if (cell && cell.type === 'k') kings[cell.color] = cell.square;
    }
  }
  if (kings.w && kings.b) {
    const df = Math.abs(kings.w.charCodeAt(0) - kings.b.charCodeAt(0));
    const dr = Math.abs(Number(kings.w[1]) - Number(kings.b[1]));
    if (Math.max(df, dr) <= 1) warnings.push('the kings are adjacent');
  }

  // the side NOT on move is in check — i.e. their king could be captured
  const flipped = parts.slice();
  flipped[1] = turn === 'w' ? 'b' : 'w';
  flipped[3] = '-';
  try {
    if (new Chess(flipped.join(' '), { skipValidation: true }).isCheck()) {
      warnings.push(`${turn === 'w' ? "Black's" : "White's"} king can be captured`);
    }
  } catch {
    /* unreadable flipped position — ignore */
  }

  return warnings;
}
